import { render, staticRenderFns } from "./Thread.vue?vue&type=template&id=4f0fe78a&"
import script from "./Thread.vue?vue&type=script&lang=js&"
export * from "./Thread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports